module.exports = __webpack_public_path__ + "img/apple.fdba09f0.svg";